<template>
  <div class="resultsOpt d-flex justify-content-end align-items-center pt-2 pt-sm-3 mt-2 mt-sm-3">
    <div class="col-4" />
    <div v-if="rascunho"
         class="paginate d-inline-flex justify-content-center align-items-center col-4">
      <p class="paginate_text small d-inline-block mt-0">
        Página
      </p>

      <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
              :class="{ 'inactive': (Number(page) === 1) }"
              :disabled="(Number(page) === 1)"
              type="button"
              title="Página anterior"
              @click="previous">
        <svg class="paginate_icon icon--xxs"
             role="presentation">
          <use :xlink:href="'#' + arrow_left.id" />
        </svg>
      </button>

      <p class="paginate_text small d-inline-block mt-0">
        <select v-model="pageActual"
                class="form-control form-control-sm"
                @change="setPage()">
          <option v-for="(value, index) in lastPage"
                  :key="`option_paginate_dashboard_${ index }_${ _uid }`">
            {{ value }}
          </option>
        </select>
      </p>

      <button class="paginate_btn btn btn-sm btn-link p-1 ml-1"
              :class="{ 'inactive': page === lastPage }"
              :disabled="(page === lastPage)"
              type="button"
              title="Próxima página"
              @click="next">
        <svg class="paginate_icon icon--xxs"
             role="presentation">
          <use :xlink:href="'#' + arrow_right.id" />
        </svg>
      </button>

      <p class="paginate_text small d-inline-block mt-0">
        {{ `de ${lastPage}` }}
      </p>
    </div>

    <div class="ordenateBox form-group mb-0 row no-gutters col-4 d-inline-flex justify-content-end p-0">
      <div v-show="orderBy !== false">
        <label for="order"
               class="label mr-2">Ordenar por</label>
        <div class="">
          <select id="order"
                  v-model="ordenate"
                  class="custom-select custom-select-sm"
                  name="order"
                  @change="updateOrder">
            <option :value="null">
              Selecione
            </option>
            <option v-for="ord in orderList.filter(order => rascunho ? order.value == 'NOME' || order.value == 'RECENTES' : order.value != 'RECENTES')"
                    :key="ord.value"
                    :value="ord.value">
              {{ ord.desc }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import RegistrosService from "@/services/Registros"

  /* icons */
  import arrow_left from '@/assets/icons/arrow-left.svg?sprite'
  import arrow_right from '@/assets/icons/arrow-right.svg?sprite'
  import delete_icon from '@/assets/icons/delete.svg?sprite'

  export default {
    name: "ResultOptions",
    props: [ 'page', 'lastPage', 'orderBy', 'excludeAll', 'listForExclude', 'updated', 'rascunho'],
    data () {
      return {
        pageActual: 1, // no inicio sempre vai ser 1
        isAllSelected: false,
        arrow_left,
        arrow_right,
        delete_icon,
        ordenate: this.orderBy,
        orderList: [{
          id: 1,
          desc: 'Nome',
          value: 'NOME'
        },{
          id: 2,
          desc: 'Registro',
          value: 'REGISTRO'
        },{
          id: 3,
          desc: 'Data Registro',
          value: 'DATA_REGISTRO'
        },{
          id: 4,
          desc: 'Data Ocorrido',
          value: 'DATA_OCORRIDO'
        },{
          id: 5,
          desc: 'Recentes',
          value: 'RECENTES'
        }]
      }
    },
    watch: {
      page () {
        this.pageActual = this.page
      },
      updated () {
        this.isAllSelected = false
      },
      rascunho () {
        if (this.rascunho) {
          this.ordenate = 'RECENTES'
        } else {
          this.ordenate = null
        }
      }
    },
    mounted () {
      if (this.rascunho) {
        this.ordenate = 'RECENTES'
      } else {
        this.ordenate = null
      }
    },
    methods: {
      excludeItems () {
        objSwal.question.title = 'Excluir registros'
        objSwal.question.text = 'Quais tipos de documentos deseja excluir ?'
        objSwal.question.cancelButtonText = 'Voltar'
        objSwal.question.confirmButtonText = 'Excluir'
        objSwal.question.input = 'select'
        objSwal.question.inputValue = 1
        objSwal.question.inputClass = 'custom-select custom-select-sm'
        objSwal.question.inputOptions = { 1: "Livro de registro", 2: "Outros documentos" }

        Swal.fire(objSwal.question).then((res) => {
          const registros = this.listForExclude.map(it => it.registro_id)

          // const params = {
          //   registros: registros,
          //   perfilLivroRegistro: (Number(res.value) === 1)
          // }

          if (!res.value) return

          /*exclusaoEmLote(params).then(res => {
            if (!res.data.every(it => !!it.success)) {
              objSwal.error.title = ''
              objSwal.error.text = 'Algums documentos podem não ter sido excluídos.'
              Swal.fire(objSwal.error)
            } else {
              objSwal.success.title = ''
              objSwal.success.text = 'Todos documentos excluídos.'
              Swal.fire(objSwal.success)
            }

            this.$emit('onUpdateSearch')
          }).catch(error => {
            objSwal.error.title = ''
            objSwal.error.text = 'Erro ao excluir documentos.'
            Swal.fire(objSwal.error)
          })*/
        })
      },
      selectAll () {
        this.isAllSelected = !this.isAllSelected

        this.$emit('onSelectAll', this.isAllSelected)
      },
      next () {
        this.$emit('onNextPage')
      },
      previous () {
        this.$emit('onPreviousPage')
      },
      setPage () {
        this.$emit('onSetPage', this.pageActual)
      },
      updateOrder () {
        this.$emit('onUpdateOrder', this.ordenate)
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .resultsOpt {
    border-top: pxToRem(1) solid $color-blue;
  }

  .paginate {
    &_text {
      font-size: pxToRem(14);
      font-weight: 500;
      margin-bottom: 0;
    }

    select {
      /*background-color: transparent;*/
      /*border: none;*/
    }

    &_icon {}

    &_btn {
      &.inactive {
        .paginate_icon {
          fill: $color-gray;
        }
      }
    }
  }

  .ordenateBox {}
</style>
